export const locale = {
  lang: 'pt',
  data: {
    'LEADER_GO': {
      'SECCION_SELECT_LEADER':{
        'TEX_CARGA_INFO': 'Loading leaders',
        'TEX_FILT_INFO': 'Líderes de filtragem',
        'TEX_TITL_TAB1': 'Seleção de líderes',
        'TEX_TITL_TAB2': 'Preview selected leaders',
        'TEX_TITL_TAB2_1':'Líderes guardados',
        'TEX_INDIC_1':'*Selecione líderes para se candidatar',
        'TEX_INDIC_BUSQ': 'Digite o nome, e-mail ou área',
        'TEX_BTN_FILT':'Filtro',
        'TH_1':'Leader name',
        'TH_2': 'Correio',
        'TH_3':'Área',
        'TH_4':'Genero',
        'TH_5':'Año',
        'TH_6':'Tipo de trabajo',
        'TH_7': 'Estatuto de utilizador CGO',
        'TH_EMA_LOCA': 'Localidade',
        'TH_EMA_SEND': 'Correio enviado',
        'TH_PUEST_LEAD':'Post',
        'STATUS_LOGIN_CGO':{
        'false':'Inactivo',
        'true':'Activo',
        'undefined':'Inactivo',
        },
        'MODAL_ACTU_BAN_UNI': 'Acrescentar líder selecionado',
        'MODAL_ACTU_BAN_MUL': 'Acrescentar líderes selecionados',
        'WARNI_NO_SELEC': 'Ainda não foi possível completar a etapa, pois nenhum líder foi selecionado',
        'COMFI_COMP_PAS': 'Você tem certeza de ter completado a etapa de seleção do líder?',
        'BTN_CONFI_OK':'OK',
        'BTN_CONFI_YES': 'Sim',
        'BTN_CONFI_NO':'Não',
        'MODAL_CONFI_GUAR_LEA':'¿Está seguro de guardar los líderes seleccionados?',
        'BTN_GUAR_LEA':'Guardar líderes seleccionados',
        'BTN_ACT_LEA':'Actualizar líderes seleccionados',
        'MSN_INGR_COD':'<span> Para enviar e-mails de convite, introduza o código a vermelho na caixa de texto ',
        'MSN_INGR_COD2':'</span>',
        'MODAL_CONFI_SEND_MAIL': 'Tem a certeza de enviar os emails?',
        'MODAL_CONFI_ACTIV_USER_CGO':'Tem a certeza de activar o utilizador?',
        'MODAL_CONFI_DESACTIV_USER_CGO':'Tem a certeza de desactivar o utilizador?',
        'MSN_INGR_COD_ACTI_USER':'<span> Para activar/desactivar o utilizador, introduza o código a vermelho na caixa de texto ',
        'MODAL_ERR_COD': 'O texto colocado não corresponde',
        'WARNI_NO_SELEC_LEA': 'Para poder enviar emails, seleccionar pelo menos um líder',
        'BTN_SEND_MAIL': 'Enviar e-mails',
        'BTN_CONFI_CONFIRMAR': 'Confirmar',
        'BTN_CONFI_CANCELAR': 'Cancelar',
        'MOD_INFO_SEN_EMA':'Envio de e-mails...',
        'SUCCE_SEN_EMA':'Eles foram enviados corretamente',
        'NO_LEAD_PRODUCT_ASO':'O certificado associado para este produto não contém utilizadores de chumbo.',
        'MOD_ACTI_USE_CGO': 'Actualização do estatuto de utilizador',
        'SUCCE_UPDA_STA_STA_USE': 'Actualizado com sucesso',
      },
      'SECCION_PROGRAMACION':{
        'MODAL_CONFI_COMPL':'Você tem certeza de ter completado a etapa de editor de correio? ',
      'FECHAS':{
        'TITULO': 'Selecionar datas',
        'BTN_TEXT': 'Selecionar datas',
        'INSTRUC_TEXT': 'Selecionar e registrar as diferentes datas disponíveis para configuração',
      },
      'CORREOS':{
        'TITULO': 'Mensagens de comunicação',
        'BTN_TEXT':'Ver mensagens de comunicação',
        'INSTRUC_TEXT':'Rever as mensagens de comunicação a serem enviadas',
       'TIPOS_CORREO':{
         'TIPO1_INVITA':{
           'TITULO': 'Mensagem de convite',
              'DESCRIP': 'Esta é a mensagem enviada aos líderes no dia do lançamento da chamada',
         },
         'TIPO2_RECOR_NO_INI':{
           'TITULO': 'Mensagem aos líderes que ainda não começaram',
              'DESCRIP': 'Esta é a mensagem de lembrete enviada aos líderes que ainda não iniciaram',
         },
         'TIPO3_RECOR_NO_FINA':{
           'TITULO': 'Mensagem para os líderes que ainda não terminaram',
              'DESCRIP': 'Esta é a mensagem de lembrete enviada aos líderes que já começaram sua pesquisa mas ainda não terminaram',
         },
       }
      },
      'MODAL_ACCIO':{
    'TIPO_ACCIO_FECH':{
       'TITU_TEXT1': 'Selecione cada uma das datas disponíveis para configurar',
      }
    },
    'ETIQ':{
      'tag_name': 'O nome do líder',
          'tag_codeCoupon': 'O código do cupom',
          'tag_productoId': 'O id do produto',
          'tag_nameCourse': 'O nome do curso',
    }
    },
    'TIP_EMAI': {
      'lanzamiento': 'Data de lançamento do convite',
        'aviso1': 'Pré-lançamento (Primeiro aviso antes do lançamento da pesquisa)',
        'aviso2': 'Pré-lançamento (Segundo aviso antes do lançamento da pesquisa)',
        'cierre': 'Data de encerramento',
        'Recordatorio1': 'Data de envio do lembrete para aqueles que ainda não começaram',
        'Recordatorio2': 'Data do envio do lembrete para aqueles que ainda não terminaram',
    },
    'SECCION_CONFIRM':{
      'BTN_CONFIRM_ENVIO':'Confirmar o envio',
      'BTN_ENVIO_CONFIRM':'O envio foi confirmado',
      'MODAL_COMPL_CONF':'Você tem certeza de ter completado a etapa de confirmação do envio?',
      'MODAL_WARNIN_CONF':'Para completar a etapa, você deve confirmar o envio dos e-mails.',
    },
    'SECCI_AVANCE':{
      'CARDS':{
        'PASO_1':{
          'TITULO': 'Progresso',
            'DESCRIP': 'Avanço dos líderes',
            'BTN_1':'Ir para o portal de contagem',
            'BTN_2':'',
        },
        'PASO_2':{
          'TITULO': 'Lembrete',
          'DESCRIP': 'Lembrete aos líderes que ainda não começaram ou terminaram o processo',
          'BTN_1': 'Lembrete',
          'BTN_2':'',
        }
      }
    },
    },
    'ACTION_GO':{
      'COLUMNAS':{
          'NameUser':'Nome',
          'email': 'Mail',
          'Area': 'Área',
          'JobTitle': 'Correio',
          'Localidad':'Localização',
          'NumberOfEmails':'Correspondência enviada',
          'Age': 'Ano',
          'Gneration': 'Gênero',
          'IdUser': 'User Id',
          'SurveyID':'Survey Id',
          'keyUserlogin': 'Senha',
          'Pass_cgo': 'Senha',
      }
    }
  }
};
